var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};
CONFUSEDCMS.eventDecorator = CONFUSEDCMS.eventDecorator || {};
CONFUSEDCMS.eventDecorator.extensions = CONFUSEDCMS.eventDecorator.extensions || {};

// Extend jQuery to add custom events
(function ($) {
    'use strict';
    var oldShow = $.fn.show;

    $.fn.show = function () {
        var ret = oldShow.apply(this, arguments);

        this.trigger('show');

        return ret;
    };
})(jQuery);

(function ($) {
    'use strict';
    var oldHide = $.fn.hide;

    $.fn.hide = function () {
        var ret = oldHide.apply(this, arguments);

        this.trigger('hide');

        return ret;
    };
})(jQuery);